// Component: CalloutCard
// Author: Aditya
import React from 'react';
import { withPlaceholder, Text, Image, Link } from '@sitecore-jss/sitecore-jss-react';
import CalloutCard from '@component/CalloutCard';
import { RoutableLink } from '../../react/RoutableLink';
import Icon from '@rotaryintl/brandcenter-icon';

const CalloutCardComponent = (props) => {
  return (
    <>
      <CalloutCard
        image={<Image field={props.fields?.image} editable={true} width="80%" />}
        title={<Text field={props.fields?.title} />}
        text={<Text field={props.fields?.copy} />}
        learnMoreLinkText={props.fields.link.value.text}
        learnMoreLink={props.fields.link.value.href ? props.fields.link.value.href : 'javascript:void(0);'}
        rightarrow={props.fields.link.value.text && <Icon iconType="chevronRight" color={'#019FCB'} size={'xs'} />}
      />
    </>
  );
};
export default withPlaceholder('jss-callout-card')(CalloutCardComponent);
